module.exports = __webpack_public_path__ + "static/media/ic-lodge.4e51d64a.svg";